const messages = {
  error: 'ERROR 404',
  subtitle: 'Parece que esta luna está abandonada.',
  noFound: '(página no encontrada)'

}

export default messages
